import type { IconDefinition } from "@fortawesome/pro-regular-svg-icons";
import {
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faCircleXmark,
  faClose,
} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box } from "@mui/material";
import React from "react";
import type { CloseButtonProps, IconProps } from "react-toastify";
import { ToastContainer } from "react-toastify";

import { useStyles } from "./styles";

const CustomCloseIcon: React.FC<CloseButtonProps> = ({ closeToast }) => (
  <Box onClick={closeToast}>
    <FontAwesomeIcon
      icon={faClose}
      size="sm"
    />
  </Box>
);

const ToastCustomIcons: { [key: string]: IconDefinition } = {
  success: faCircleCheck,
  info: faCircleInfo,
  warning: faCircleExclamation,
  error: faCircleXmark,
  default: faCircleInfo,
};

const CustomIcons: React.FC<IconProps> = ({ type }) => {
  const iconType = ToastCustomIcons[type];

  return (
    <FontAwesomeIcon
      icon={iconType}
      size="lg"
      style={{ height: "20px", paddingTop: "2px" }}
    />
  );
};

const StyledToastContainer: React.FC = () => {
  const { classes } = useStyles();

  return (
    <ToastContainer
      className={classes.root}
      position="bottom-left"
      hideProgressBar
      newestOnTop
      closeButton={CustomCloseIcon}
      icon={CustomIcons}
      limit={1}
      autoClose={2500}
      pauseOnFocusLoss={false}
    />
  );
};

export default StyledToastContainer;
